<template>
  <table class="table table-striped table-condensed">
    <thead>
    <tr>
      <th class="col-xs-6">
        <a href="#" @click.prevent="sort('time_based_subchannel_name')">
          Subchannel <i class="fa fa-sort"></i>
        </a>
      </th>

      <th class="col-xs-4">
        <a href="#" @click.prevent="sort('index')">
          Index <i class="fa fa-sort"></i>
        </a>
      </th>

      <th class="col-xs-4">
        <a href="#" @click.prevent="sort('revenue')">
          Revenue <i class="fa fa-sort"></i>
        </a>
      </th>

      <th class="col-xs-4">
        <a href="#" @click.prevent="sort('target')">
          Target <i class="fa fa-sort"></i>
        </a>
      </th>

      <th class="col-xs-6">
        <a href="#" @click.prevent="sort('difference')">
          Difference <i class="fa fa-sort"></i>
        </a>
      </th>
    </tr>
    </thead>

    <tbody>
    <tr v-for="row in sortedRows">
      <td>
        <span :style="{'background-color': row.time_based_subchannel_color}">
          &nbsp;&nbsp;&nbsp;&nbsp;
        </span>

        &nbsp;

        <router-link
            :to="'/portals/' + portal.id + '/time-based-subchannels/' + row.time_based_subchannel_id + '/dashboard/' + year"
        >
          {{ row.time_based_subchannel_name }}
        </router-link>
      </td>

      <td>
        <index-number :value="row.index"></index-number>
      </td>

      <td>
        {{ row.revenue | price }}
      </td>

      <td>
        {{ row.target | price }}
      </td>

      <td>
        <difference-number :value="row.difference"></difference-number>
      </td>
    </tr>
    </tbody>

    <tfoot>
    <tr>
      <td>
        Total
      </td>

      <td>
        <index-number :value="totalIndex"></index-number>
      </td>

      <td>
        {{ totalRevenue | price }}
      </td>

      <td>
        {{ totalTarget | price }}
      </td>

      <td>
        <difference-number :value="totalDifference"></difference-number>
      </td>
    </tr>
    </tfoot>
  </table>
</template>

<script>
import DifferenceNumber from '@/components/Numbers/DifferenceNumber'
import IndexNumber from '@/components/Numbers/IndexNumber'
import Permissions from '@/mixins/Permissions'

export default {
  components: {DifferenceNumber, IndexNumber},

  mixins: [Permissions],

  props: ['year', 'portal', 'rows'],

  data() {
    return {
      sortBy: 'time_based_subchannel_name',
      sortDirection: -1
    }
  },

  computed: {
    sortedRows() {
      return this.rows.sort((a, b) => {
        return a[this.sortBy] > b[this.sortBy] ? -this.sortDirection : this.sortDirection
      })
    },

    totalIndex() {
      if (!this.totalTarget) {
        return null
      }

      return this.totalRevenue / this.totalTarget * 100
    },

    totalRevenue() {
      return this.rows.reduce((total, row) => total + row.revenue, 0)
    },

    totalTarget() {
      return this.rows.reduce((total, row) => total + row.target, 0)
    },

    totalDifference() {
      return this.rows.reduce((total, row) => total + row.difference, 0)
    }
  },

  methods: {
    sort(key) {
      if (this.sortBy === key) {
        return this.sortDirection = -this.sortDirection
      }

      this.sortDirection = key === 'time_based_subchannel_name' ? -1 : 1

      this.sortBy = key
    }
  }
}
</script>
